/* eslint-disable react/prop-types */
import React from "react";
import { Button, TextField, makeStyles } from "@material-ui/core";
import useFormFields from "lib/forms";
import { Auth, Amplify } from "aws-amplify";
import mixpanelTrack, { mixpanelBase } from "app/common/MixpanelComponent";
import { useHistory, useRouteMatch } from "react-router-dom";
import { browserName, browserVersion, osName } from "react-device-detect";
import { REACT_APP_BASE_URL } from "resources/constants";
import awsConfig, { awsInternalConfig } from "aws-exports";
import Cookies from "universal-cookie";

const useStyles = makeStyles(() => ({
  formButton: {
    marginTop: "20px",
  },
  recoveryMesage: {
    fontSize: "12px",
  },
  sendCodeTextField: {
    marginTop: "5px",
  },
}));

const cookies = new Cookies();

const SignInForm = ({
  setIsLoading,
  setCognitoUser,
  setAlertMessage,
  setDisplayNewPasswordForm,
}) => {
  const history = useHistory();
  const classes = useStyles();
  const { url } = useRouteMatch();
  const [fields, handleFieldChange] = useFormFields({
    email: "",
    password: "",
  });

  function keyAllowed(event) {
    const regex = new RegExp("^[A-Za-z0-9.@-]");
    const key = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  function handleSubmit(event) {
    const fieldsEmail = fields.email;
    event.preventDefault();
    cookies.set(
      "userEmail",
      JSON.stringify({
        fieldsEmail,
      }),
      { path: "/" }
    );
    Amplify.Logger.LOG_LEVEL = "INFO"; // We write INFO level logs throughout app
    if (fields.email.split("@")[1] === "wiseathena.com") {
      Amplify.configure(awsInternalConfig);
    } else {
      Amplify.configure(awsConfig);
    }
    setIsLoading(true);
    let isLoggedIn = false;
    Auth.signIn(fields.email, fields.password)
      .then(async (user) => {
        setCognitoUser(user);
        setAlertMessage("");
        if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          setDisplayNewPasswordForm(true);
        } else {
          isLoggedIn = true;
          try {
            const baseBody = {
              service_type: "mixpanel",
              properties: {
                browser: browserName,
                browser_version: browserVersion,
                os: osName,
                screen_width: window.screen.width,
                screen_height: window.screen.height,
                current_url: REACT_APP_BASE_URL + url,
              },
            };
            mixpanelBase(baseBody);
          } catch (e) {
            mixpanelTrack("Log in error", { error: e.message });
          }
        }
      })
      .catch((err) => {
        setAlertMessage(err.message);
      })
      .finally(() => {
        setIsLoading(false);
        if (isLoggedIn) history.push({ pathname: "/" });
      });
  }

  return (
    <>
      <form onSubmit={handleSubmit} data-testid="sign-in-form">
        <TextField
          variant="outlined"
          size="small"
          margin="normal"
          required
          fullWidth
          id="email"
          label="Email"
          name="email"
          autoComplete="email"
          onChange={handleFieldChange}
          onKeyPress={keyAllowed}
        />
        <TextField
          variant="outlined"
          size="small"
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          id="password"
          autoComplete="current-password"
          onChange={handleFieldChange}
        />
        <Button
          fullWidth
          type="submit"
          variant="contained"
          color="primary"
          className={classes.formButton}
        >
          Sign In
        </Button>
      </form>
    </>
  );
};

export default SignInForm;
